<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAirplaneClock } from "@mdi/js"

export default {
  name: "AirplaneClockIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiAirplaneClock,
    }
  }
}
</script>
